// src/components/Navbar.js

import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Button,
  ListItemIcon,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  // Estado para abrir/fechar o Drawer
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Função para alternar o Drawer
  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  // Itens do menu (Drawer)
  const menuItems = [
    {
      text: "Configurações",
      icon: <SettingsIcon />,
      action: () => navigate("/settings"),
    },
    {
      text: "Logout",
      icon: <LogoutIcon />,
      action: () => handleLogout(),
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  // Conteúdo do Drawer (para telas menores)
  const drawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {menuItems.map((item) => (
          <ListItem button key={item.text} onClick={item.action}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Ícone de menu para Drawer em telas menores */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
          sx={{ mr: 2, display: { xs: "block", md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Título ou Logo */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} onClick={() => navigate("/")}>
          marcaki
        </Typography>

        {/* Botões de Ação para telas maiores */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
          <Button color="inherit" onClick={() => navigate("/user/home")}>
            Menu
          </Button>
          <Button color="inherit" onClick={() => navigate("/user/appointments")}>
            Agendamentos
          </Button>
          <Button color="inherit" onClick={() => navigate("/user/settings")}>
            Configurações
          </Button>
          <Button color="inherit" onClick={handleLogout}>
            Sair
          </Button>
        </Box>

        {/* Drawer para telas menores */}
        <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
          {drawerList}
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
